import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2, Lock } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Connexion impossible.");
    } finally { setLoading(false); }
  };

  const field = "w-full bg-transparent border-b border-white/20 focus:border-electric outline-none py-3 text-white placeholder:text-white/30 transition-colors text-base";

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 mb-10">
          <img src="/karams-logo.png" alt="Karams Studio" className="h-12 w-auto" />
          <span className="text-[10px] tracking-[0.3em] uppercase text-secondary2">Espace admin</span>
        </div>
        <h1 className="font-serif text-4xl text-white mb-8">Connexion</h1>
        <form onSubmit={submit} className="space-y-6" data-testid="admin-login-form">
          <input data-testid="admin-email-input" type="email" className={field} placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="admin-password-input" type="password" className={field} placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} />
          {error && <p data-testid="admin-login-error" className="text-red-400 text-sm">{error}</p>}
          <button data-testid="admin-login-btn" type="submit" disabled={loading}
            className="w-full inline-flex items-center justify-center gap-3 px-8 py-4 bg-surface text-white border border-white/10 rounded-full text-[13px] tracking-[0.12em] uppercase hover:border-electric hover:text-electric transition-colors disabled:opacity-60">
            {loading ? <Loader2 size={16} className="animate-spin" /> : <Lock size={15} />} Se connecter
          </button>
        </form>
      </div>
    </div>
  );
}
